<div class="custom-mat-dialog-form">
  <div>
    <div>
      <H5>Master Alert Window Configuration</H5><br />
    </div>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="mt-2">
        Controller type: <br />
        <mat-select placeholder="Please select" style="width:300px;" class='form-control'
          name="Controller Type" required formControlName="ControllerType">
          @for (c of controllerTypes; track c; let i = $index) {
            <mat-option value="{{c.BK}}">
              {{c.Description}}
            </mat-option>
          }
        </mat-select>
        <br />
        @if (errorCT) {
          <span style="color:red;">*Mandatory field<br /></span>
        }
        <br />
        <br />
        <div id="DivInterval input">
          Time Window (seconds): <br />
          <input class="form-control" type="number" name="Time Window" max="86400" min="0" maxlength="5" required formControlName="TxtTimeWindowInSeconds" (input)="onTimeWindowInSecondsChange($event)">
          <br />
          @if (errorTW) {
            <span style="color:red;">*Mandatory field<br /></span>
          }
          @if (errorTWvalue) {
            <span style="color:red;">*Valid values between 0 and 86400 <br /></span>
          }
        </div>

      </div>

      <br />


      <div class="mt-2 right">
        <button type="button"
          class="btn btn-danger"
          (click)="onNoClick()">
          Cancel
        </button>
        <button type="button"
          class="btn btn-primary"
          (click)="onSubmit()">
          Save
        </button>
      </div>
    </form>
  </div>
</div>
